/* eslint-disable no-useless-escape */

import { dateFormatUI } from 'models/time/arbor-date';
import moment from 'moment';

export const resourceTypeFormatter = (value: any): string => {
  if (value && value.name) {
    return value.name;
  }
  return '-';
};

export const dateConvert = (value: unknown): string => {
  const defaultValue = '-';

  if (value && typeof value === 'string') {
    return moment.utc(value).format(dateFormatUI);
  }

  return defaultValue;
};

export const numberParser = (e: any, nDecimals = 0): void => {
  const onlyNumbers = '0123456789';
  const dot = '.';
  if (nDecimals === 0) {
    if (!onlyNumbers.includes(e.key)) {
      e.target.value = e.target.value.replace(e.key, '');
    }
  } else if (nDecimals > 0) {
    if (onlyNumbers.includes(e.key) || e.key === dot) {
      e.target.value = e.target.value.replace(/(^[\.\s])|(\.\.$)/g, '').replace(/\.+/g, '.');
      const decimalPoint = e.target.value.indexOf('.');
      if (decimalPoint !== -1) {
        e.target.value = e.target.value.substring(0, decimalPoint + 1 + nDecimals);
      }
    } else e.target.value = '';
  } else if (nDecimals === -1) {
    if (onlyNumbers.includes(e.key) || e.key === dot) {
      e.target.value = e.target.value.replace(/(^[\.\s])|(\.\.$)/g, '').replace(/\.+/g, '.');
    } else e.target.value = '';
  }
};

export const statusFormatter = (value: unknown): string => {
  if (value) {
    return 'Active';
  }
  return 'Deprecated';
};
